import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../common/Modal';
import PostsForm from './PostsForm';

function PostFormModal({ content, zoneId, onComplete, onClose }) {
  return (
    <Modal
      isOpen
      closeModal={onClose || onComplete}
      className="modal-booklet-form modal-post-form"
      showClose={false}
    >
      <h2>{content ? 'Redigerar inlägg' : 'Skapar inlägg'}</h2>
      <PostsForm content={content} zoneId={zoneId} onComplete={onComplete} />
    </Modal>
  );
}

PostFormModal.propTypes = {
  content: PropTypes.object,
  zoneId: PropTypes.string.isRequired,
  onComplete: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};

PostFormModal.defaultProps = {
  content: null,
  onClose: null,
};

export default PostFormModal;
